/**
 * API: Reporte de Estudiantes por Carrera (Perfil Académico).
 *
 * Endpoint: GET /api/escolar/reportes/estudiantes-carrera/
 *
 * Filtros soportados:
 *  - id_ciclo_escolar (req)
 *  - id_programa      (req)
 *  - id_campus        (opc)
 *  - id_seccion       (opc)
 *  - page             (opc, default 1)
 *  - page_size        (opc, default 15)
 *  - all              (opc, '1' devuelve todos sin paginar)
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

/**
 * @param {Object} params
 * @param {number|string} params.id_ciclo_escolar
 * @param {number|string} params.id_programa
 * @param {number|string} [params.id_campus]
 * @param {number|string} [params.id_seccion]
 * @param {number}        [params.page=1]
 * @param {number}        [params.page_size=15]
 * @param {boolean}       [params.all=false]
 * @returns {Promise<{page:number,page_size:number,total:number,total_pages:number,filtros:object,resultados:Array}>}
 */
export async function getReporteEstudiantesCarrera({
  id_ciclo_escolar,
  id_programa,
  id_campus,
  id_seccion,
  page = 1,
  page_size = 15,
  all = false,
} = {}) {
  if (!id_ciclo_escolar) {
    throw new Error("El parámetro 'id_ciclo_escolar' es requerido.");
  }
  if (!id_programa) {
    throw new Error("El parámetro 'id_programa' es requerido.");
  }

  const qs = new URLSearchParams();
  qs.set('id_ciclo_escolar', String(id_ciclo_escolar));
  qs.set('id_programa', String(id_programa));
  if (id_campus !== undefined && id_campus !== null && id_campus !== '' && id_campus !== 'todos') {
    qs.set('id_campus', String(id_campus));
  }
  if (id_seccion !== undefined && id_seccion !== null && id_seccion !== '' && id_seccion !== 'todos') {
    qs.set('id_seccion', String(id_seccion));
  }
  if (all) {
    qs.set('all', '1');
  } else {
    qs.set('page', String(page));
    qs.set('page_size', String(page_size));
  }

  const url = `${API_BASE}/escolar/reportes/estudiantes-carrera/?${qs.toString()}`;
  const res = await fetch(url, { headers: getHeaders(), cache: 'no-store' });

  if (!res.ok) {
    let errorMsg = `Error ${res.status} al obtener el reporte`;
    try {
      const errorData = await res.json();
      errorMsg = errorData.error || errorMsg;
    } catch (_) { /* ignore */ }
    throw new Error(errorMsg);
  }

  return await res.json();
}

export default getReporteEstudiantesCarrera;
